import { createSelector } from 'reselect';
import { DeepReadonly } from 'utility-types/dist/mapped-types';
import { ReduxState } from '../state';
import { InstitutionAdminSettingsState } from './types';

export const selectInstitutionAdminSettings = (
  state: ReduxState
): DeepReadonly<InstitutionAdminSettingsState> =>
  state.InstitutionAdminSettings;

export const selectPaginatedInstitutionEnrolments = createSelector(
  selectInstitutionAdminSettings,
  (institutionAdminSettings) =>
    institutionAdminSettings.paginatedInstitutionEnrolments
);

export const selectPaginatedPendingInvitations = createSelector(
  selectInstitutionAdminSettings,
  (institutionAdminSettings) =>
    institutionAdminSettings.paginatedPendingInvitations
);
